<template>
  <div>
    <el-form ref="ticketForm"
             :model="editInfo"
             :rules="rules"
             label-position="left"
             label-width="90px">

      <el-form-item label="工单标签" prop="tag" :rules="rules.tag">
        <el-radio-group v-model="editInfo.tag" fill="#F16622">
          <el-radio-button v-for="item in this.$config.ticketTagList" :label="item.value">{{ item.label }}
          </el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="业务类型" prop="type" :rules="rules.type">
        <el-radio-group v-model="editInfo.type">
          <el-radio v-for="item in this.$config.ticketTypeList" :label="item.value">{{ item.label }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="标题" prop="title" :rules="rules.title">
        <el-input type="text" style="width: 457px;" show-word-limit v-model="editInfo.title" maxlength="50" clearable
                  placeholder="请输入标题"></el-input>
      </el-form-item>
      <div v-if="isBugReport">
        <el-form-item label="环境" prop="env" :rules="rules.env">
          <el-radio v-model="editInfo.env" label="1">测试环境</el-radio>
          <el-radio v-model="editInfo.env" label="2">正式环境</el-radio>
        </el-form-item>

        <el-form-item label="app_key" prop="appKey" :rules="rules.app_key">
          <el-input v-model="editInfo.appKey" style="width: 457px;" maxlength="50" clearable
                    placeholder="请输入app key"></el-input>
        </el-form-item>

        <el-form-item label="signature" prop="signature" :rules="rules.signature">
          <el-input :class="[isBugReport ? 'is-required' : '']" v-model="editInfo.signature" style="width: 457px;"
                    maxlenght="100" clearable placeholder="请输入signature"></el-input>
        </el-form-item>

      </div>

      <el-form-item label="描述" prop="description" :rules="rules.description">
        <el-input type="textarea" :rows="6" maxlength="500" style="width: 457px;" show-word-limit
                  v-model="editInfo.description" clearable
                  placeholder="请描述详细问题包括：场景,现象等"></el-input>
      </el-form-item>
      <el-form-item label="附件">
        <el-upload
            action="/ajax/common/interface/image/upload"
            accept="image/png, image/jpeg, image/jpg"
            name="image"
            multiple
            :headers="headerData"
            list-type="picture-card"
            :limit="5"
            :file-list="fileList"
            :before-upload="beforeUploadPicture"
            :on-progress="uploadProgress"
            :on-preview="preview"
            :on-remove="remove"
            :on-success="uploadSuccess"
            :on-exceed="handleExceed"
            :show-file-list="true">
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
      <el-button class="submit-btn" @click="submit">提交</el-button>
    </el-form>
    <div>
      <el-dialog title="图片预览" top="70px"  class="small-el-dialog" :visible.sync="imgVisible">
        <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: "TicketAdd",
  props: ["show"],
  data() {
    return {
      editInfo: {
      },
      defaultInfo: {
        tag: '', // 标签
        title: '', // 主题
        type: '', // 类型
        appKey: null, // appkey
        signature: null, // signature
        env: null, // 环境
        description: '',
        images: [],
        id: ""
      },
      headerData: {
        Authorization: localStorage.getItem('token')
      },
      fileList: [],
      uploadComplete: true,
      imgVisible: false, // 上传图片预览
      dialogImageUrl: '', // 图片预览地址
      rules: {
        description: [
          {required: true, message: '请输入描述', trigger: 'blur'}
        ],
        tag: [
          {required: true, message: '请选择标签', trigger: 'blur'}
        ],
        title: [
          {required: true, message: '请输入主题', trigger: 'blur'}
        ],
        type: [
          {required: true, message: '请选择业务类型', trigger: 'blur'}
        ],
        app_key: [{required: true, message: '请填写app_key', trigger: 'blur'}],
        signature: [{required: true, message: '请填写signature', trigger: 'blur'}],
        env: [{required: true, message: '请选择环境', trigger: 'blur'}]
      },
      bugReportRules: {

      }
    }
  },
  computed: {
    isBugReport() {
      return this.editInfo.tag === 2;
    },
  },
  methods: {
    submit() {
      if (this.isLoading) {
        return;
      }
      this.$refs.ticketForm.validate(valid => {
        if (valid) {
          this.showCommonLoading();
          this.$axios.post('/ajax/ticket/add', this.editInfo).then(res => {
            this.hideCommonLoading();
            if (res.data.ret === 0) {
              this.editInfo = this.defaultInfo;
              this.fileList = [];
              this.$emit('closeEditDialog');
              this.$message.success("创建成功");
            }
          }).catch(e => {
            this.hideCommonLoading();
          })
        }
      });
    },
    preview(file) {
      this.imgVisible = true;
      this.dialogImageUrl = file.url;
      this.click();
    },
    remove(file, fileList) {
      this.fileChanged(fileList);
    },
    uploadProgress(event, file, fileList) {
      this.uploadComplete = false;
    },
    beforeUploadPicture(file) {
      if (file.size > 2 * 1024 * 1024) {
        this.$message.error("上传图片不能大于2M");
        return false;
      }
    },
    uploadSuccess(res, file, fileList) {
      this.uploadComplete = true;
      this.fileChanged(fileList);
    },

    fileChanged(fileList) {
      this.fileList = fileList;
      this.editInfo.images = [];
      this.fileList.forEach(file => {
        this.editInfo.images.push({'name': file.name, 'url': file.response.data});
      });
    },

    handleExceed() {
      this.$message.warning("最多上传5张图片")
    },


  },
}
</script>

<style lang="scss" scoped>
.submit-btn {
  margin-left: 90px;
  width: 480px;
  background: #F16622;
  color: #fff;
  margin-left: 90px;
  border: none;
  height: 50px;
}
</style>


// WEBPACK FOOTER //
// src/components/ticket/add.vue